import React, { Component } from 'react'

class DefaultLayout extends Component {
    render() {
        return (
            <div className="container-fluid">
                <div className="e-content">
                    <div className="row">
                        <div className="col">
                            <br />
                        </div>
                    </div>
                    <div className="row flex-lg-nowrap">
                        <div className="col">
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DefaultLayout
